import { render, staticRenderFns } from "./contactsMenu.vue?vue&type=template&id=d2d0a332&scoped=true"
import script from "./contactsMenu.vue?vue&type=script&lang=js"
export * from "./contactsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d0a332",
  null
  
)

export default component.exports